import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Box, Text, Input, ListItem, UnorderedList } from '@chakra-ui/react'
import { Auth } from './Auth';
const Tags = ({ isTitle, orderData, orderDetails }) => {
    const [tags, setTags] = useState([]);
    const [inputValue, setInputValue] = useState("");


    // Adding and removing tags functionality
    // ADD TAGS
    const addTag = (tag) => {
        // setTags((prevTags) => [...prevTags, tag]);
        let data = JSON.stringify({
            "tag": `${tag}`,
            "orderId": orderData.id,
            "orderItemSeqId": orderDetails.orderItemSeqId
          });
          
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/item/tags`,
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': Auth()
              },
            data : data
          };
          
          axios.request(config)
          .then((response) => {
            console.log(JSON.stringify(response.data));
            setTags((prevTags) => [...prevTags, {"id":response.data.id,"orderId":response.data.orderId,"orderItemSeqId":response.data.orderItemSeqId,"orderItemCurrentStatus":response.data.orderItemCurrentStatus,"tagId":response.data.tagId,"tag":{"title":tag}}])
          })
          .catch((error) => {
            console.log(error);
          });
    }

    // DELETE TAG
    const removeTag = (index,renderTag) => {
        setTags((prevTags) => prevTags.filter((_, i) => i !== index));
    
        let data = '';

        let config = {
        method: 'delete',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/item/tags?tagId=${renderTag.id}&orderId=${orderData?.id}&orderItemSeqId=${orderDetails?.orderItemSeqId}`,
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': Auth()
          },
        data : data
        };

        axios.request(config)
        .then((response) => {
        console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
        console.log(error);
        });
    }

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    }

    const handleInputKeyDown = (event) => {
        if (event.key === "Enter" && inputValue.length > 0 && tags.length >= 0) {
            addTag(inputValue.trim());
            setInputValue("");
        }
        if (event.key === "Backspace" && inputValue.length === 0 && tags.length > 0) {
            removeTag(tags.length - 1);
        }
    }

    const handleTagClick = (index,renderTag) => {
        removeTag(index,renderTag);
    }

    const sanitizeTag = (tag) => {
        return tag.replace(/[^\w -]/g, "").trim().replace(/\W+/g, "-");
    }

    const handleInputBlur = () => {
        if (inputValue.length > 0) {
            addTag(sanitizeTag(inputValue));
            setInputValue("");
        }
    }

     // ### GET SAVED TAG OF ORDER ITEM SEQ ID ###
     useEffect(() => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/item/tags?orderId=${orderData.id}&orderItemSeqId=${orderDetails?.orderItemSeqId}`,
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': Auth()
              },
          };
          
          axios.request(config)
          .then((response) => {
            console.log(JSON.stringify(response.data));
            setTags(response.data)
          })
          .catch((error) => {
            console.log(error);
          });
       },[orderData, orderDetails])

    return (
            <>
            
            <Box my={5} py={isTitle ? 3 : 0}>
            
                <UnorderedList display={'flex'} flexWrap={'wrap'} border={'1px solid rgba(0, 0, 0, 0.7)'} borderRadius={'3px'} px={2} py={3} m={0}>
                {!isTitle && <Text as={'span'} fontWeight={'semibold'}>Tags : &nbsp;</Text>}
                    {tags.map((renderTag, index) => {
                        return (
                            <ListItem display={'flex'} rounded={'md'} justifyContent={'space-between'} color={'white'} alignItems={'center'} listStyleType={'none'} key={index} mr={2} mb={2} px={4} py={4} h={'30px'} bgColor={'#3182ce'}>
                                {renderTag.tag.title}
                                <Box as="button" ml={'10px'} onClick={() => handleTagClick(index,renderTag)}>
                                    &times;
                                </Box>
                            </ListItem>
                        )
                    })}
                   
                    <Input
                        h={'30px'}
                        flex={1}
                        p={0}
                        border={'unset'}
                        outline={'unset'}
                        focusBorderColor="transparent"
                        value={inputValue}
                        onChange={handleInputChange}
                        onKeyDown={handleInputKeyDown}
                        onBlur={handleInputBlur}
                    />
                </UnorderedList>
                {/* <Input value={inputValue} onChange={(e) => setInputValue(e.target.value)} onKeyDown={handleKeyDown}/> */}
            </Box>
            </>
    )
}

export default Tags